function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { flexbox, layout, space } from 'styled-system';
import styled from 'styled-components';
import { createBreakpointMap, getPaddingMapFromPaddingProp } from '../helpers/styled-helpers';
import { StyledCol } from './style';
var StyledColWithFlexboxAndSpaceProps = /*#__PURE__*/styled(StyledCol).withConfig({
  displayName: "col__StyledColWithFlexboxAndSpaceProps",
  componentId: "sc-1b4hx0e-0"
})(["", ";", ";", ";"], flexbox, layout, space);

var Col = props => {
  var offsetMap;
  var rightOffsetMap;
  var sizeMap;
  var reverseMap;
  var firstMap;
  var lastMap;
  var backgroundColorMap;
  var paddingRightMap = createBreakpointMap('0px');
  var paddingLeftMap = createBreakpointMap('0px');

  var {
    offset,
    size,
    reverse,
    first,
    last,
    backgroundColor,
    rightOffset,
    children
  } = props,
      styledSystemProps = _objectWithoutProperties(props, ["offset", "size", "reverse", "first", "last", "backgroundColor", "rightOffset", "children"]);

  if (reverse) {
    reverseMap = createBreakpointMap(reverse);
  }

  if (first) {
    firstMap = createBreakpointMap(first);
  }

  if (last) {
    lastMap = createBreakpointMap(last);
  }

  if (offset) {
    offsetMap = createBreakpointMap(offset);
  }

  if (rightOffset) {
    rightOffsetMap = createBreakpointMap(rightOffset);
  }

  if (size) {
    sizeMap = createBreakpointMap(size);
  }

  if (backgroundColor) {
    backgroundColorMap = createBreakpointMap(backgroundColor);
  }

  if (props.p || props.padding) {
    paddingRightMap = getPaddingMapFromPaddingProp(props.p || props.padding, 'right');
    paddingLeftMap = getPaddingMapFromPaddingProp(props.p || props.padding, 'left');
  }

  if (props.paddingRight || props.pr) {
    paddingRightMap = getPaddingMapFromPaddingProp(props.paddingRight || props.pr, 'right');
  }

  if (props.paddingLeft || props.pl) {
    paddingLeftMap = getPaddingMapFromPaddingProp(props.paddingLeft || props.pl, 'left');
  }

  return /*#__PURE__*/React.createElement(StyledColWithFlexboxAndSpaceProps, _extends({
    offsetMap: offsetMap,
    rightOffsetMap: rightOffsetMap,
    sizeMap: sizeMap,
    paddingLeftMap: paddingLeftMap,
    paddingRightMap: paddingRightMap,
    lastMap: lastMap,
    firstMap: firstMap,
    reverseMap: reverseMap,
    backgroundColorMap: backgroundColorMap
  }, styledSystemProps), children);
};

export default Col;